var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"pixie",class:[ _vm.dir == 'left' ? 'pixie-left': 'pixie-right' ],style:({zIndex: _vm.zindex}),attrs:{"id":"pixie"}})}
var staticRenderFns = []

export { render, staticRenderFns }